import LocalizedStrings, {
  GlobalStrings,
  LocalizedStringsMethods,
} from "react-localization";
import { produce } from "immer";
import { RootState } from "../base/types/RootState";
import { createSelector } from "reselect";

export interface LocalizationReducer {
  base: GlobalStrings<string>;
}

const initialState: LocalizationReducer = require("./localization.json");
const localizationReducer = produce(
  (draft: LocalizationReducer, action: any) => {},
  initialState
);

export default localizationReducer;

const getUserLanguageState = (state: RootState) => state.language.language.Code;
export const userLanguageState = createSelector(
  [getUserLanguageState],
  (lang) => lang
);

const returnLocolaziedString = (
  locale: GlobalStrings<string>,
  lang?: string
): LocalizedStringsMethods => {
  const l = new LocalizedStrings(locale);
  if (lang) l.setLanguage(lang);
  return l;
};
const getLocaleBase = (state: RootState) => state.locale.base;
export const getLocalized = createSelector(
  [getLocaleBase, getUserLanguageState],
  (locale, lang) => returnLocolaziedString(locale, lang)
);
